import { useEffect } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { setIsIntegrationScriptLoadedAction } from 'js/components/system/App/store/actions';

import * as pas from '../pas';

export const usePas = () => {
    const dispatch = useDispatch();
    const { deviceId, deliveryPlatform, clientPlatform } = useDeviceSelector(pick(['deviceId', 'deliveryPlatform', 'clientPlatform']));

    const {
        ssoPasDomain,
        casinoName,
        clientType,
        clientSkin,
        ssoPasJsURLs,
        ssoPasExternalJsUrl
    } = useAppSelector(pick([
        'ssoPasDomain',
        'casinoName',
        'clientType',
        'clientSkin',
        'ssoPasJsURLs',
        'ssoPasExternalJsUrl'
    ]));

    useEffect(() => {
        if (!ssoPasDomain || !casinoName) {
            return;
        }

        (async () => {
            try {
                await pas.init({
                    ssoPasDomain,
                    casinoName,
                    clientType,
                    clientSkin,
                    deviceId,
                    deliveryPlatform,
                    clientPlatform,
                    ssoPasJsURLs,
                    ssoPasExternalJsUrl
                });

                dispatch(setIsIntegrationScriptLoadedAction(true));

            } catch (error) {
                dispatch(setIsIntegrationScriptLoadedAction(false));
            }
        })();
    }, [
        ssoPasDomain,
        casinoName,
        clientType,
        clientSkin,
        deviceId,
        deliveryPlatform,
        clientPlatform,
        ssoPasJsURLs,
        ssoPasExternalJsUrl,
        dispatch
    ]);
};
